<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <p class=".title ma-2">Add a line </p>
            <v-form ref="addHspr" v-model="addHsprValid">
                <v-row no-gutters>
                    <v-col class="pa-2">
                        <v-select v-model="fcti_code" required :items="fcti_codeKeuzes" item-value="fcti_code" item-text="fctitaal_oms" label="Item" dense :rules="fcti_codeRules"></v-select>
                    </v-col>
                </v-row>

                <v-row v-if="hspr.betreft == 'Payment'" no-gutters>
                    <v-col class="pa-2">
                        <v-menu
                            v-model="hspr_dtmenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            readonly 
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="hspr_dt" label="Date" v-on="on" :rules="hspr_dtRules"></v-text-field>
                            </template>
                            <v-date-picker v-model="hspr_dt" :first-day-of-week="1" @input="hspr_dtmenu = false"></v-date-picker>
                        </v-menu>  
                    </v-col>
                </v-row>

                <v-row v-if="hspr.betreft == 'Payment' && hobo_codeKeuzes.length > 0" no-gutters>
                    <v-col class="pa-2">
                        <v-select v-model="hobo_rowid" :items="hobo_codeKeuzes" item-value="hobo_rowid" item-text="hobo_methode_oms" label="Online payment" dense></v-select>
                    </v-col>
                </v-row>

                <v-row  no-gutters v-if="fcti_code === 'v2b'">
                    <v-col class="pa-2">
                        <v-text-field v-model="akcc_code" label="Discount code" dense></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="fcti_code === 'v2b'">
                    <v-col class="pa-2">
                        <v-text-field v-model="hspr_bedrag" required label="Amount" :prefix=hspr.valu_code type="number" :rules="hspr_bedragRules2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters v-else>
                    <v-col class="pa-2">
                        <v-text-field v-model="hspr_bedrag" required label="Amount" :prefix=hspr.valu_code type="number" :rules="hspr_bedragRules1"></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
            <v-card-actions>
                <v-btn class="primary mx-2" small @click="calcDiscount" v-if="fcti_code === 'v2b'">Calculate Discount</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHspr" :disabled="!addHsprValid">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                addHsprValid: false,
                huov_encrid: null,
                fcti_code: '',
                akcc_code: '',
                hspr_bedrag: null,
                fcti_codeKeuzes: [],
                hobo_codeKeuzes: [],
                hspr: {},
                hspr_dtmenu: false,
                fcti_codeRules: [
                    v => (v && v.length >= 1) || "An fcti code is required"
                ],
                hspr_dtRules: [
                    v => (v && v.length >= 10) || "A Date is required"
                ],
                // hspr_bedragRules: [
                //     v => (v && v.length >= 1) || "An amount is required"
                // ],   
                hspr_bedragRules1: [
                    v => {
                        if (!isNaN(parseFloat(v))) return true;
                        return  "An amount needs to be given (0 is allowed)";
                    }
                ], 
                hspr_bedragRules2: [
                    v => {
                        if (!isNaN(parseFloat(v)) && (v > 0 || v < 0)) return true;
                        return  "An amount needs to be <> 0";
                    }
                ],   
            }
        },
        methods: {
            open(huov_encrid,betreft) {
                var deze = this;
                this.$emit("showSnackbar");
                this.dialog = true;
                this.huov_encrid = huov_encrid;
                this.fcti_codeKeuzes.length = 0;
                this.hobo_codeKeuzes.length = 0;
                this.hspr_dt = '';
                this.hobo_rowid = '';
                this.hspr_bedrag = '';
                this.fcti_code = '';
                this.hspr = {};
                this.$axios.post("ares/json/ares/huov/hspr/getHuovToAddHspr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuovToAddHspr"
                    },
                    getHuovToAddHspr: {
                        huov_encrid: huov_encrid,
                        betreft: betreft
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hspr = res.data.getHuovToAddHspr;
                        res.data.getHuovToAddHspr.fcti_codeKeuzes.forEach(function(fcti) {
                            deze.fcti_codeKeuzes.push(fcti); 
                        });
                        if (res.data.getHuovToAddHspr.hobo_codeKeuzes) {
                            res.data.getHuovToAddHspr.hobo_codeKeuzes.forEach(function(hobo) {
                                deze.hobo_codeKeuzes.push(hobo); 
                            });
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
            },
            addHspr() { 
                this.$axios.post("ares/json/ares/huov/hspr/addHspr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHspr"
                    },
                    addHspr: {
                        huov_encrid: this.huov_encrid,
                        fcti_code: this.fcti_code,
                        hspr_dt: this.hspr_dt,
                        hobo_rowid: this.hobo_rowid,
                        akcc_code: this.akcc_code,
                        hspr_bedrag: parseFloat(this.hspr_bedrag)
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning",
                        }); 
                    } else { 
                        setTimeout(() => { this.$router.reload('/huov/onHuov/' + res.data.addHspr.huov_encrid); }, 2000);              
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHspr.text,
                            color: res.data.addHspr.color
                        }); 
                        this.dialog = false;
                    }
                });
            },
            calcDiscount() { 
                this.$axios.post("ares/json/ares/huov/hspr/calcHsprDiscount.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "calcHsprDiscount"
                    },
                    calcHsprDiscount: {
                        huov_encrid: this.huov_encrid,
                        cDiscountCode: this.akcc_code
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "warning"
                        }); 
                    } else {           
                        this.hspr_bedrag = res.data.calcHsprDiscount;
                        this.$refs.addHspr.resetValidation();
                        this.$refs.addHspr.validate();
                    }
                });
            },
        }
    }
</script>

